// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllocationLocations > .sidepanel-header {
  border-bottom: none;
}
.AllocationLocations > .sidepanel-content {
  display: flex;
  flex-direction: column;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/AdOps/Segments/Sidebar/Allocations/AllocationLocations.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAFJ","sourcesContent":[".AllocationLocations {\n\n  > .sidepanel-header {\n    border-bottom: none;\n  }\n\n  > .sidepanel-content {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
